module.exports = __webpack_public_path__ + "img/sunnergy.304ea25f.webp";